import { ADYEN_ENVIRONMENT, ADYEN_CLIENT_KEY } from '@reverbdotcom/env';

export const adyenEnvironment = {
  clientKey: ADYEN_CLIENT_KEY,
  environment: ADYEN_ENVIRONMENT,
};
